<template>
  <div class="box7">
    <pageTitle
      title="掌握的越多离梦想就更近"
      text="自信来自实力，实力来自拼搏！"
    />

    <div class="content">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="block">
            <div class="title">
              {{ item.title }}
            </div>
            <div class="text">
              <p v-for="i in item.arr" :key="i">{{ i }}</p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      list: [
        {
          title: "内容一：入侵检测与网络攻防",
          arr: [
            "Kali Linux操作系统实战",
            "网络防御技术",
            "网络攻击技术 ",
            "异常通信行为分析",
            "加密流量还原",
            "大项目：入侵检测与网络攻防",
          ],
        },
        {
          title: "内容二：负载均衡远程服务调用系统",
          arr: [
            "Reactor模式并发Service",
            "DNS与路由Service",
            "负载均衡代理Service",
            "信息上报Service",
            "压力测试 ",
            "大项目：lars负载均衡系统",
          ],
        },
        {
          title: "内容三：打车软件项目",
          arr: [
            "Java基础编程",
            "Android基础UI开发",
            "JNI终端编程业务 ",
            "地图编程及服务端业务",
          ],
        },
      ],
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        // centeredSlides: true,

        pagination: {
          el: ".swiper-pagination-box7",
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box7 {
  padding: 80px 0px 88px;
  position: relative;
  width: 100%;
  background: linear-gradient(180deg, #f6fcff 0%, #e9f2ff 100%);
  overflow: hidden;
  background: url("../../../assets/coursePage/cPuls/box7/bgc.png") no-repeat;
  background-size: cover;
  .content {
    position: relative;
    margin-top: 48px;
    padding-left: 32px;
  }

  .swiper-container {
    overflow: inherit;
  }

  .swiper-slide {
    width: 540px;
    margin-right: 32px;
  }

  .block {
    width: 540px;
    height: 620px;
    background-color: #ffffff;

    background-repeat: no-repeat;
    background-size: 64px 62px;
    background-position-x: 447px;
    background-position-y: 420px;
    box-shadow: 0px 0px 30px 0px #dbedff;
    border-radius: 20px;
    .title {
      position: relative;
      padding-left: 32px;

      width: 100%;
      height: 92px;
      background: linear-gradient(270deg, #3499ff 0%, #027fff 100%);
      border-radius: 20px 20px 0px 0px;
      font-size: 30px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 48px;
      box-sizing: border-box;
      line-height: 92px;

      &::after {
        content: "赠送";
        position: absolute;
        width: 96px;
        height: 42px;
        background: linear-gradient(270deg, #ffb600 0%, #ff7f00 100%);
        border-radius: 200px 200px 200px 4px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 42px;
        text-align: center;
        right: 0;
        top: -20px;
      }
    }
    .text {
      margin-top: 32px;
      margin-left: 32px;
      p {
        width: 476px;
        height: 64px;
        background: #f2f8ff;
        border-radius: 8px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1d2129;
        line-height: 64px;
        padding-left: 24px;
        box-sizing: border-box;
        margin-bottom: 16px;
      }
      p:last-child {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
    }
  }
}
</style>
